export default function(value) {

    function humanize() {
        if (value != null) {
            var format

            if (value < 1000) {
                format = value + ' m'
            } else {
                format = Math.round(value / 1000 * 10) / 10 + ' km'
            }
            return format
        }
        return '---'
    }

    function format(unit) {
        if (value != null) {
            var format

            switch (unit.toLowerCase()) {
                case 'km': 
                    format = Math.round(value / 1000 * 10) / 10 + ' km'
                    break
                default: 
                    format = value + ' m'
            }

            return format
        }
        return ''
    }

    return {humanize, format}
}


// WEBPACK FOOTER //
// ./lib/core/distance.js